import React from 'react';
import { connect } from 'react-redux';

import { CheckoutSection, checkoutNotesLabelStyle } from '../../components';
import { userNotes as userNotesAction } from './notesActions';
import UserNotes from '../../../SharedComponents/Notes/UserNotes';

export const CheckoutNotes = (props) => {
    const {
        userNotes,
        setUserNotes
    } = props;
    
    return (
        <CheckoutSection label={'Notes'} hidden={false}>
            <UserNotes
                userNotes={userNotes}
                notesLabelStyle={checkoutNotesLabelStyle}
                setUserNotes={setUserNotes}
            />
        </CheckoutSection>
    );
};

const mapNotesStateToProps = (state) => {
    return {
        userNotes: state.entities.UserNotes
    }
}

const mapNotesDispatchToProps = (dispatch) => {
    return {
        setUserNotes: (notes) => dispatch(userNotesAction(notes)),
    }
}

const CheckoutNotesContainer = connect(mapNotesStateToProps, mapNotesDispatchToProps)(CheckoutNotes);
export default CheckoutNotesContainer;